import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { generateIntegrationToken } from '@/features/integrations/api/generate-integration-token';
import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';
import { useToast } from '@/shared/hooks/use-toast';

type GenerateIntegrationTokenInput = {
  tokenName: string;
  projectId: number;
};

export const useGenerateIntegrationToken = () => {
  const { toast } = useToast();
  const { t } = useTranslation('integrations', {
    keyPrefix: 'integration_token_management',
  });
  const currentOrgId = useCurrentOrgId();

  return useMutation({
    mutationFn: ({ tokenName, projectId }: GenerateIntegrationTokenInput) =>
      generateIntegrationToken(currentOrgId ?? 0, projectId, tokenName),
    onError: (error) => {
      toast({
        title: t('errors.generation_error'),
        description: error.message,
      });
    },
  });
};
